import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset } from "rbx";

import { EditFormButtonGroup } from "../inputs";

import VehicleELDReadingForm from "./VehicleELDReadingForm";
import {
  UPDATE_VEHICLE_ELD_READING_MUTATION,
  DELETE_VEHICLE_ELD_READING_MUTATION
} from "../../graphql/Vehicles/Vehicles.graphql";

import { ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  RecId: "",
  ELDDate: "",
  State: "",
  DriverRecIdRef: "",
  OdometerReading: "",
  MilesUsed: "",
  Cost: "",
  Qty: ""
};

function EditVehicleELDReadingForm({ VehicleELDReading, onComplete }) {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...VehicleELDReading
  });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const [updateVehicleELDReading, { loading }] = useMutation(
    UPDATE_VEHICLE_ELD_READING_MUTATION,
    {
      refetchQueries: ["ALL_VW_VEHICLE_ELD_READING_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateVehicleELDReading({
        variables: {
          data: {
            ...obj,
            OdometerReading: parseFloat(inputs.OdometerReading),
            State: inputs.State,
            DriverRecIdRef: parseFloat(inputs.DriverRecIdRef),
            Cost: parseFloat(inputs.Cost),
            MilesUsed: parseFloat(inputs.MilesUsed),
            Qty: parseFloat(inputs.Qty)
          },
          where: { RecId: VehicleELDReading.RecId }
        }
      });
      toast.success("Vehicle ELD Reading updated successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error updating Vehicle ELD Reading.");
    }
  };
  return (
    <div className="edit-vehicle-eld-reading-form">
      <Title>Update Vehicle ELD Reading</Title>
      <form id="edit-vehicle-eld-reading-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <VehicleELDReadingForm inputs={inputs} onChange={handleChange} />
          <EditFormButtonGroup
            deleteMutation={DELETE_VEHICLE_ELD_READING_MUTATION}
            form="edit-vehicle-eld-reading-form"
            refetchQueries={["ALL_VW_VEHICLE_ELD_READING_QUERY"]}
            variables={{ where: { RecId: VehicleELDReading.RecId } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </div>
  );
}

EditVehicleELDReadingForm.propTypes = {
  VehicleELDReading: PropTypes.object,
  onComplete: PropTypes.func
};
EditVehicleELDReadingForm.defaultProps = {
  VehicleELDReading: {}
};
export default EditVehicleELDReadingForm;
